import React, { useEffect, useState } from 'react'
import PercentageWithArrow from '../../ui/PercentageWithArrow'
import { Skeleton, Select, MenuItem, Typography, InputBase, Paper } from '@mui/material'
import useTopGainersAndLosers from '../hooks/useTopGainersAndLosers'
import CompanyDrawer from '../../CompanyDrawer'
import styles from '../../../pages/Dashboard.module.scss'
import axios from 'axios'
// import useSWR from "swr"

const CompanyDataAndChange = ({symbol, change_precent, company_name}) => (
    <CompanyDrawer ticker={symbol} companyName={company_name} presentedData={<PercentageWithArrow number={change_precent/100}/>} />
)

export default function TopGainersAndLosers(){
    // const { companies } = useTopGainersAndLosers()

    const [companies, setCompanies] = useState(null)

    const [isGainers, setIsGainers] = useState('Gainers')
    const [type, setType] = useState('My Watchlist')

    const options = [{value: 'Gainers', name: 'Gainers'}, {value: 'Losers', name: 'Losers'}]

    const options2 = [{value:'My Watchlist', name: 'My Watchlist'},{value: 'US Tickers', name: 'US Tickers'}]

    const chooseGainersOrLosers = (e) => setIsGainers(e.target.value)

    const companiesInfo = (data) => (data?.map(company => <CompanyDataAndChange {...company} key={company.symbol}/>))

    const getCompiniesData = (type) =>{
        let addURL = ''
        if (type == 'My Watchlist') addURL = 'my_watchlist'
        else if (type == 'US Tickers') addURL = 'us_tickers'
        // const { data: companiesData } = useSWR(`/api/getTops?type=`+addURL)
        axios.get(`/api/getTops?type=`+addURL)
        .then(res => res.data)
        .then(data => setCompanies(data)).catch(err=>{
            console.log(err);
        })
    }


    useEffect(()=>{
        getCompiniesData(type)
        return () => {}
    },[type])

    return(
        <div>
            <div className={styles['title']}>
                <Typography variant='h3'>
                    Top
                </Typography>
                <Select
                    variant='standard'
                    value={isGainers}
                    onChange={chooseGainersOrLosers}
                    input={<InputBase classes={{input: styles['input']}}/>}
                    classes={{select: styles['select']}}
                >
                    {options.map(value => <MenuItem value={value.value} key={value.name}>{value.name}</MenuItem>)}
                </Select>
                <Typography variant='h3'>
                    In 
                </Typography>
                <Select
                    variant='standard'
                    value={type}
                    onChange={(e)=>{setCompanies(null);setType(e.target.value)}}
                    input={<InputBase classes={{input: styles['input']}}/>}
                    classes={{select: styles['select']}}
                >
                    {options2.map(value => <MenuItem value={value.value} key={value.name}>{value.name}</MenuItem>)}
                </Select>
                {/* <Typography variant='h3'>
                    In US Exchange
                </Typography> */}
            </div>
            <Paper className={styles['companies-drawer-conatiner']}>
               {companies 
                ? companiesInfo(isGainers === 'Gainers' ? companies.gainers : companies.losers)
                :  <Skeleton variant="rect" width="300px" height="100px" />}
            </Paper>
        </div>)
}